import { a as attr } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const WithSuccessText = (Base) => {
  class ElementWithSuccessText extends Base {
  }
  __decorateClass([
    attr({ attribute: "success-text" })
  ], ElementWithSuccessText.prototype, "successText");
  return ElementWithSuccessText;
};

export { WithSuccessText as W };
